import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import ReactResizeDetector from 'react-resize-detector/build/withPolyfill';
/**
 * リサイズ時のイベントを検知するためのコンポーネント
 * @param props
 * @constructor
 */
export const ResizeDetector = (props) => {
    const { children, onResize, targetRef } = props;
    return (_jsx(ReactResizeDetector, Object.assign({ onResize: onResize, targetRef: targetRef }, { children: children })));
};
